import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import "../warehouses/warehouses.scss";
import Navbar from "../../components/navbar/navbar";
import Create from "../../components/Create/Create";
import api from "../../services/api";

// Iconos MUI (para renderizar el icono guardado como string)
import * as Icons from "@mui/icons-material";

const Warehouses = () => {
  const [showForms, setShowForms] = useState(false);
  const [almacen, setAlmacen] = useState([]); // ✅ mejor como array
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ✅ Token desde local o session
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const tokenType =
    localStorage.getItem("token_type") ||
    sessionStorage.getItem("token_type") ||
    "Bearer";

  useEffect(() => {
    fetchAlmacenes();

    // refresco cada 10 min como tenías
    const interval = setInterval(fetchAlmacenes, 600000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAlmacenes = async () => {
    if (!token) {
        navigate("/login", { replace: true });
      return;
    }

    try {
      setLoading(true);

      // ✅ Endpoint nuevo (almacenes del usuario)
      const response = await api.get("/getalmacenes");

      setAlmacen(response.data?.almacenes || []);
    } catch (error) {
      console.error("Error al obtener los almacenes:", error);

      // Si token inválido/expirado
      if (error.response?.status === 401) {
        alert("Sesión expirada. Vuelve a iniciar sesión.");
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleOpenForms = () => setShowForms(true);
  const handleCloseForms = () => {
    setShowForms(false);
   
  };

  const goToAlmacen = (alm) => {
    navigate(`/tablestorage/${alm.id}`, { state: { almacen: alm } });
  };

  return (
    <div className="body-w">
      {/* Navbar */}
      <Navbar />

      <div className="container-warehouse">
        {showForms && (
          <div className="modal-overlay">
            <Create onClose={handleCloseForms} onCreated={fetchAlmacenes} />
          </div>
        )}

        {/* contenedor de los almacenes */}
        <div className="container">
          <div className="header">
            <h1 className="text" style={{color:"#4f46e5"}}>Almacenes</h1>
          </div>

          {/* divisor */}
          <div className="divider"></div>

          {/* contenedor para los almacenes */}
          <div className="contenedor-selector">
              <div className="wrapper">
                  {loading ? (
                  <div className="estado-centrado">
                      <p>Cargando almacenes...</p>
                  </div>
                  ) : almacen && almacen.length > 0 ? (
                  almacen.map((alm) => {
                      const IconComp = alm.icono && Icons[alm.icono] ? Icons[alm.icono] : null;

                      return (
                      <button key={alm.id} className="item" onClick={() => goToAlmacen(alm)}>
                          <h3 className="tittle-item">{alm.nombre}</h3>

                          <div className="icon-item">
                          {IconComp ? <IconComp style={{ fontSize: 70, color: "#4f46e5" }} /> : null}
                          </div>

                          

                      </button>
                      );
                  })
                  ) : (
                  <div className="estado-centrado">
                      <p>No hay almacenes disponibles.</p>
                  </div>
                  )}
              </div>
          </div>
        </div>

        {/* botón + */}
        <div className="footer">
          <button className="button-plus" onClick={handleOpenForms}>
            <AddIcon className="icon-plus" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Warehouses;
